(function (Translator) {
    // de
    Translator.add("address", "Adresse:", "PayseraMapBundle", "de");
    Translator.add("friday", "Freitag", "PayseraMapBundle", "de");
    Translator.add("monday", "Montag", "PayseraMapBundle", "de");
    Translator.add("no_results", "Keine Treffer gefunden", "PayseraMapBundle", "de");
    Translator.add("saturday", "Samstag", "PayseraMapBundle", "de");
    Translator.add("search_placeholder", "Geben Sie das Fragment ein", "PayseraMapBundle", "de");
    Translator.add("service.cash_in", "Einzahlung", "PayseraMapBundle", "de");
    Translator.add("service.cash_out", "Abhebung", "PayseraMapBundle", "de");
    Translator.add("service.identification", "Vornahme der Identifikation", "PayseraMapBundle", "de");
    Translator.add("service.pay", "Zahlungen", "PayseraMapBundle", "de");
    Translator.add("services", "Dienstleistungen:", "PayseraMapBundle", "de");
    Translator.add("sunday", "Sonntag", "PayseraMapBundle", "de");
    Translator.add("thursday", "Donnerstag", "PayseraMapBundle", "de");
    Translator.add("tuesday", "Dienstag", "PayseraMapBundle", "de");
    Translator.add("wednesday", "Mittwoch", "PayseraMapBundle", "de");
    Translator.add("working_hours", "Arbeitszeit:", "PayseraMapBundle", "de");
})(Translator);
